module.exports = __webpack_public_path__ + "static/media/IconTemplates_-74.bd92998b.svg";